import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createUserSlice } from "./slices/loginSlice";
import { createDropdownValuesSlice } from "./slices/dropdownValuesSlice";
import { createKycDocumentsSlice } from "./slices/kycDocumentsSlice";
import { createDecisionMakingSlice } from "./slices/decisionMakingSlice";
import { createProductDetailsSlice } from "./slices/productDetailsSlice";
import { createBankSlice } from "./slices/bankSlice";
import { createLoanSlice } from "./slices/loanSlice";
import { createRepaymentSlice } from "./slices/repaymentSlice";
import { createBoosterSourceSlice } from "./slices/boosterSourceSlice";

const useAppStore = create(
  persist(
    (set, get) => ({
      ...createUserSlice(set, get),
      ...createDropdownValuesSlice(set, get),
      ...createKycDocumentsSlice(set, get),
      ...createDecisionMakingSlice(set, get),
      ...createProductDetailsSlice(set, get),
      ...createBankSlice(set, get),
      ...createLoanSlice(set, get),
      ...createRepaymentSlice(set, get),
      ...createBoosterSourceSlice(set, get),
      clearStorage: () => {
        useAppStore.persist.clearStorage();
        localStorage.removeItem("loan-app-storage");
        localStorage.clear();
      },
    }),
    {
      name: "loan-app-storage",
      partialize: (state) => ({
        userToken: state.userToken,
        refreshToken: state.refreshToken,
        fcmToken: state.fcmToken,
        userInfo: state.userInfo,
        appDetails: state.appDetails,
        locationDetails: state.locationDetails,
        kycDocuments: state.kycDocuments,
        applicationId: state.applicationId,
        digilockerUniqueId: state.digilockerUniqueId,
        digilockerTransactionId: state.digilockerTransactionId,
        okycTxnId: state.okycTxnId,
        ckycDownloadId: state.ckycDownloadId,
        bankAccId: state.bankAccId,
        loanId: state.loanId,
        esignSelfie: state.esignSelfie,
        sanctionBankAccountNum: state.sanctionBankAccountNum,
        sanctionBankName: state.sanctionBankName,
        esignDocId: state.esignDocId,
        loanScheduleId: state.loanScheduleId,
        repaymentTransactionId: state.repaymentTransactionId,
        paymentSuccessData: state.paymentSuccessData,
        isRecallLoan: state.isRecallLoan,
        isForecloseLoan: state.isForecloseLoan,
        boosterSource: state.boosterSource,
        enachSkipAllowed: state.enachSkipAllowed,
        isDummyUser: state.isDummyUser,
      }),
    }
  )
);

export default useAppStore;
